import { useEffect } from "react";
import { installPsychAssistInfractionSoundBridge } from "../../utils/psychassistInfractionSound";

export function PsychAssistSoundBridge() {
  useEffect(() => installPsychAssistInfractionSoundBridge(), []);
  return null;
}
